const ParsePolicyString = (policyString) => {
  const policy = policyString.split('(')[0].trim();
  const match = policyString.match(/\(([^|]+)\|([^)]+)\)$/g);
  if (match) {
    const address = match[0].replace('(', '').replace(')', '').split('|');
    return { policy, addressLine1: address[0], postcode: address[1], address: `${address[0]}, ${address[1]}` };
  }
  return { policy: policyString };
}
export default {
  install(Vue) {
    Vue.filter('policy', function (policyString, field, backupValue) {
      const value = ParsePolicyString(policyString)[field];
      if (!value || value.length === 0) {
        return backupValue;
      }
      return value;
    });
    Vue.prototype.$hasRole = function (user, role) {
      return user.role.indexOf(role) !== -1;
    }
  },
};